import numeral from 'numeral'
import React, { memo, useMemo } from 'react'

import ArrowLink from '@/assets/arrowLink.png'
import BridgeLogo from '@/assets/bridgeLogo.png'
import BridgeLogo_Light from '@/assets/bridgeLogo_light.png'
import DataLoading from '@/assets/data-loading.png'
import PosLogo from '@/assets/posLogo.png'
import PosLogo_Light from '@/assets/posLogo_light.png'
import { useLocalStorage } from '@/context/localstorage-context'
import { useQueryStatsInfo } from '@/utils/queries'

import {
  BRIDGE_Description,
  BridgeContent,
  BridgeData,
  BtnLink,
  Container,
  Description,
  Img,
  LogoCon,
  POS_Description,
  PosContent,
  PosData,
  StyledNavLink,
  Text1,
  Title,
} from './index.module'

interface Props {}

const Index: React.FC<Props> = memo(() => {
  const { theme } = useLocalStorage()
  const { data: statsInfo, isLoading } = useQueryStatsInfo()

  const storemanTvl = useMemo(() => {
    if (isLoading) {
      ;<img src={DataLoading} alt="loading" width="100" />
    } else {
      if (statsInfo && statsInfo.sotremen) {
        return numeral(
          statsInfo.sotremen.totalDepositRaw / Math.pow(10, 18),
        ).format('0,0')
      } else {
        return 0
      }
    }
  }, [statsInfo, isLoading])

  const postvl = useMemo(() => {
    if (isLoading) {
      return <img src={DataLoading} alt="loading" width="100" />
    } else {
      if (statsInfo && statsInfo.pos) {
        return numeral(
          statsInfo.pos.curTotalAmountRaw / Math.pow(10, 18),
        ).format('0,0')
      } else {
        return 0
      }
    }
  }, [statsInfo, isLoading])

  const isDark = useMemo(() => theme === 'dark', [theme])

  return (
    <Container>
      <PosContent className="bg-white dark:bg-common-1">
        <LogoCon>
          <Img src={isDark ? PosLogo : PosLogo_Light} alt="logo" width={136} />
        </LogoCon>
        <Title color={isDark ? '#fff' : '#818D96'}>· Galaxy Consensus ·</Title>
        <PosData>{postvl}</PosData>
        <Text1>Total Staked Amount (WAN)</Text1>
        <Description>{POS_Description}</Description>
        <StyledNavLink to={'/pos'}>
          <BtnLink>
            <span className="text-[16px]">Delegate to POS</span>
            <img src={ArrowLink} alt="group" width={24} />
          </BtnLink>
        </StyledNavLink>
      </PosContent>
      <BridgeContent className="bg-white dark:bg-common-1">
        <LogoCon>
          <Img
            src={isDark ? BridgeLogo : BridgeLogo_Light}
            alt="logo"
            width={136}
          />
        </LogoCon>
        <Title color={isDark ? '#fff' : '#818D96'}>· Universal Bridges ·</Title>
        <BridgeData>{storemanTvl}</BridgeData>
        <Text1>Total Staked Amount (WAN)</Text1>
        <Description>{BRIDGE_Description}</Description>
        <StyledNavLink to={'/bridge'}>
          <BtnLink>
            <span className="text-[16px]">Delegate to Bridge</span>
            <img src={ArrowLink} alt="group" width={24} />
          </BtnLink>
        </StyledNavLink>
      </BridgeContent>
    </Container>
  )
})
Index.displayName = 'Index'

export default Index
